import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isLoading", "onChange", "size"];
import { LayoutBox } from '../Layout/LayoutBox';
import { LayoutHorizontal } from '../Layout/LayoutHorizontal';
import { Skeleton } from '../Skeleton/Skeleton';
import styled from 'styled-components';
import { Toggle as ToggleFoundations } from 'foundations-components/transitional/components/Toggle';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TOGGLE_SIZE = '26px';
const SkeletonBox = styled(LayoutBox).withConfig({
  displayName: "Toggle__SkeletonBox",
  componentId: "sc-1sijspd-0"
})(["box-shadow:0 0 0 1px var(--layout-lib-background-color);border-radius:var(--layout-lib-border-radius);z-index:1;"]);
const SkeletonToggle = ({
  children,
  isLoading
}) => {
  if (isLoading) return /*#__PURE__*/_jsxs(LayoutHorizontal, {
    gap: "0",
    position: "relative",
    children: [/*#__PURE__*/_jsx(Skeleton, {
      blockSize: TOGGLE_SIZE,
      inlineSize: TOGGLE_SIZE,
      isLoading: isLoading
    }), /*#__PURE__*/_jsx(SkeletonBox, {
      position: "relative",
      children: /*#__PURE__*/_jsx(Skeleton, {
        blockSize: TOGGLE_SIZE,
        inlineSize: TOGGLE_SIZE,
        isLoading: isLoading
      })
    })]
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export const Toggle = _ref => {
  let {
      isLoading,
      onChange,
      size = 'extra-small'
    } = _ref,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(restWithSpacingProps);
  const handleToggleChange = event => {
    onChange(event.target.checked);
  };
  return /*#__PURE__*/_jsx(SkeletonToggle, {
    isLoading: isLoading,
    children: /*#__PURE__*/_jsx(ToggleFoundations, Object.assign({}, rest, spacingProps, {
      onChange: handleToggleChange,
      size: size
    }))
  });
};